"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessDataContent = void 0;
const lib_1 = require("@brandfree-front/lib");
const react_1 = __importDefault(require("react"));
const ShowRequests_1 = __importDefault(require("../../ShowRequests"));
const RootStore_1 = require("../../../stores/RootStore");
const AccessDataContent = () => {
    const { translate } = react_1.default.useContext(RootStore_1.RootStoreContext).translateStore;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ShowRequests_1.default, { requestType: "ACCESS" }),
        react_1.default.createElement(lib_1.Text, null,
            react_1.default.createElement("p", null, translate('gdpr.privacy.accessData.text1')),
            react_1.default.createElement("p", { className: "text__margin-double" },
                react_1.default.createElement("i", null, translate('gdpr.privacy.accessData.text2'))),
            react_1.default.createElement("p", { className: "text__margin-double" }, translate('gdpr.privacy.accessData.text3')),
            react_1.default.createElement(lib_1.List, { className: "text-bold" },
                react_1.default.createElement(lib_1.ListItem, null,
                    translate('gdpr.privacy.accessData.text4'),
                    ' ',
                    react_1.default.createElement(lib_1.Anchor, { url: "https://www.telia.ee/abi/juhend/3741" }, translate('gdpr.privacy.accessData.button.here')),
                    "."),
                ' ',
                react_1.default.createElement(lib_1.ListItem, null, translate('gdpr.privacy.accessData.text5'))))));
};
exports.AccessDataContent = AccessDataContent;
